import {
    Create,
    SimpleForm,
    SelectInput,
    useGetList,
    TextInput,
    SelectArrayInput,
    AutocompleteArrayInput,
    ReferenceArrayInput,
    required,
    ImageInput,
    ImageField
} from 'react-admin';
import { nokSoloOrCompanyOptions, nokStatus, smtpZones} from "../../defaults/defaults";
import { JSX } from "react";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";
import { SenderDescriptionInput } from "../edit/components/Noks/SenderDescriptionInput";

export const NokWebsiteCreate: () => JSX.Element = (): JSX.Element => {
    const { data, total, isPending, error } = useGetList(
        'industries',
        {
            pagination: { page: 1, perPage: 500 },
        }
    );
    let industries: { id: string, name: string }[] = [];
    if (data) {
        for (const item of data) {
            industries.push({
                id: item.id,
                name: item.name
            });
        }
    }

    // Numbers for the website's own industries, which HQ-API links by id (`nokwebsiteDataProvider`).
    const industryIds: { id: number, name: string }[] = industries.map( (item: { id: string, name: string }): { id: number, name: string } => ({ id: Number(item.id), name: item.name }) );

    if (isPending) {
        return null;
    }

    return (
        <Create redirect="edit" >
            <SimpleForm >
                <TextInput source="name" validate={[required()]} />
                <TextInput source="description" multiline rows={ 5 } />
                <SelectArrayInput source="targetIndustries" choices={ industries } />
                <AutocompleteArrayInput source="industries"
                                        label="Website industries"
                                        choices={ industryIds }
                                        defaultValue={ [] }
                                        sx={ { minWidth: 300 } }
                                        helperText="The industries this website's own business is in. Target industries are the ones it shops." />
                <SelectInput source="soloOrCompany" choices={ nokSoloOrCompanyOptions } />
                <SenderDescriptionInput />
                <ReferenceArrayInput source="nokPersonas" reference="nok_personas" />
                <SelectInput source="smtpServerZone"
                             choices={ smtpZones }
                             helperText="This value must match the MailGun sending server for the domain or will fail to send!"
                             validate={ [required()] } />
                <TextInput source="url"
                           validate={[required()]}
                           helperText="This domain needs to be set in MailGun for emails to work" />
                <ImageInput source="logo"
                            label="Company Logo"
                            helperText="This image needs to be on the Nok site server to render in email footer" >
                    <ImageField source="src" title="title" />
                </ImageInput>
                <TextInput source="productionLogoPath" />
                <SelectInput source="status" choices={ nokStatus } defaultValue="active" />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
